import { render, staticRenderFns } from "./page13.vue?vue&type=template&id=12d2c3e4&scoped=true"
import script from "./page13.vue?vue&type=script&lang=js"
export * from "./page13.vue?vue&type=script&lang=js"
import style0 from "./page13.vue?vue&type=style&index=0&id=12d2c3e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d2c3e4",
  null
  
)

export default component.exports